import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { CommentaryModule } from '../../modules/commentary/CommentaryModule.tsx';

export const CommentaryRouteElement = () => (
  <ModuleContainer moduleID="commentary" compact>
    <CommentaryModule />
  </ModuleContainer>
);
